import React, { useContext } from 'react';
import { Search, Bell, HelpCircle, User } from 'lucide-react';
import { UserContext } from '../../context/UserContext';
export function Header() {
  const {
    userRole,
    toggleRole
  } = useContext(UserContext);
  return <header className="bg-white border-b border-gray-200 z-30" data-id="element-689">
      <div className="px-4 sm:px-6 lg:px-8" data-id="element-690">
        <div className="flex items-center justify-between h-16" data-id="element-691">
          <div className="flex-1 max-w-md" data-id="element-692">
            <div className="relative" data-id="element-693">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-694">
                <Search className="h-5 w-5 text-gray-400" data-id="element-695" />
              </div>
              <input type="text" placeholder="Rechercher..." className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm transition-all" data-id="element-696" />
            </div>
          </div>
          <div className="flex items-center gap-3 ml-4" data-id="element-697">
            <button onClick={toggleRole} className="px-4 py-2 text-sm font-medium rounded-lg bg-blue-50 text-blue-700 hover:bg-blue-100 transition-colors" data-id="element-698">
              {userRole === 'employee' ? 'Mode Manager' : 'Mode Employé'}
            </button>
            <button className="p-2 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors" data-id="element-699">
              <HelpCircle className="h-5 w-5" data-id="element-700" />
            </button>
            <button className="p-2 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 relative transition-colors" data-id="element-701">
              <Bell className="h-5 w-5" data-id="element-702" />
              <span className="absolute top-1.5 right-1.5 block h-2 w-2 rounded-full bg-red-500 ring-2 ring-white" data-id="element-703"></span>
            </button>
            <button className="h-9 w-9 rounded-lg bg-blue-600 flex items-center justify-center text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors" data-id="element-704">
              <User className="h-5 w-5" data-id="element-705" />
            </button>
          </div>
        </div>
      </div>
    </header>;
}